<template>
  <header
    v-if="routeName !== 'Receipts'"
    class="corp-header"
    :class="{ 'corp-header--ml': !mainMenuIsOpen }"
  >
    <Header :screenWidth="screenWidth" />

    <MobileHeader :screenWidth="screenWidth" />

    <NavigationDrawer
      :screenWidth="screenWidth"
      :miniDrawer="miniDrawer"
      @handleMiniDrawer="handleMiniDrawer"
    />

    <Brand v-if="!miniDrawer" :miniDrawer="miniDrawer" />
  </header>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { hasRole, isArray } from 'utils/functions'
import Header from 'components/corpHeader/Header'
import MobileHeader from 'components/corpHeader/MobileHeader'
import NavigationDrawer from 'components/corpHeader/NavigationDrawer'
import Brand from 'components/corpHeader/Brand'

export default {
  name: 'CorpHeader',
  components: {
    Header,
    MobileHeader,
    NavigationDrawer,
    Brand
  },
  data () {
    return {
      miniDrawer: false,
      screenWidth: 0
    }
  },
  computed: {
    ...mapState({
      mainMenuIsOpen: ({ mainMenu }) => mainMenu.isOpen,
      company: state => state.company.selectedCompany
    }),

    routeName () {
      return this.$route.name
    },

    routeId () {
      if (this.$route.params.id) {
        return Number(this.$route.params.id)
      } else if (this.company) {
        return this.company.id
      } else {
        return null
      }
    }
  },
  methods: {
    ...mapActions({
      setCostCenterCounter: 'costCenter/set'
    }),

    hasRole (group, role) {
      return hasRole(group, role)
    },

    isValidArray (val) {
      return isArray(val)
    },

    setScreenWidth () {
      this.screenWidth = window.innerWidth
    },

    handleMiniDrawer () {
      this.miniDrawer = !this.miniDrawer
    },

    async costCenterCounter (companyId) {
      if (!this.hasRole('costCenter', 'ROLE_GET_COSTCENTER')) return

      try {
        const { data: res } = await this.$apiService.getCostCentersAll(
          { limit: 1 },
          { page: 1 },
          { company: companyId }
        )
        this.setCostCenterCounter(res.length)
      } catch (err) {
        console.log('Error', err)
      }
    },

    checkScreenWidth () {
      this.miniDrawer = this.screenWidth < 1200
    }
  },
  watch: {
    miniDrawer (val) {
      if (this.screenWidth >= 768) return

      if (!val) {
        document.querySelector('html').style.overflow = 'hidden'
        return
      }

      document.querySelector('html').style.overflow = ''
    },

    '$route' (to, from) {
      if (this.screenWidth <= 1199 && (to.name !== from.name)) {
        setTimeout(() => { this.miniDrawer = true }, 500)
      }
      if (to && to.meta && to.meta.hideChat) {
        document.body.classList.add('hide__chat__class')
      } else {
        document.body.classList.remove('hide__chat__class')
      }
    },

    company (val) {
      val && this.costCenterCounter(val.id)
    }
  },
  mounted () {
    this.setScreenWidth()
    this.checkScreenWidth()
    window.addEventListener('resize', this.setScreenWidth, false)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setScreenWidth)
  }
}
</script>

<style lang="scss">
.corp-header {
  z-index: 4;

  &.corp-header--ml {

    .toolbar--white:before {
      left: 0;

      @media (min-width: 768px) {
        /* left: 184px; */
      }
    }
  }

  .toolbar--white {
    border-bottom: 0;
    background-color: $gray-7 !important;

    @media (min-width: 768px) {
      background: white !important;
    }

    &:before {
      background-color: $gray-2;
      bottom: 0;
      content: "";
      height: 1px;
      left: 0;
      position: absolute;
      right: 0;
      transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
      width: 100%;
    }
  }
}
</style>
